import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../../Viewpoint.js";
import e from "../../core/Collection.js";
import { isSome as n, get as r, isNone as o } from "../../core/maybe.js";
import { getMetersPerUnitForSR as a } from "../../core/unitUtils.js";
import { t as i, a as s } from "../../chunks/common.js";
import { f as c, r as u, t as f, i as l, s as m, a as y, b as p } from "../../chunks/mat2d.js";
import { c as g } from "../../chunks/mat2df64.js";
import { s as h, c as x, g as b, h as d, n as w, f as j, i as G, j as M, k, l as A, t as R, m as S } from "../../chunks/vec2.js";
import { a as v, f as P } from "../../chunks/vec2f64.js";
import q from "../../geometry/Extent.js";
import F from "../../geometry/Geometry.js";
import I from "../../geometry/Point.js";
import N from "../../geometry/SpatialReference.js";
import { earth as z } from "../../geometry/support/Ellipsoid.js";
import { isValid as V, getInfo as E } from "../../geometry/support/spatialReferenceUtils.js";
import { canProject as L, project as O } from "../../geometry/support/webMercatorUtils.js";
var W = 39.37,
    C = 180 / Math.PI;

function U(t, e, n) {
  var r = s(e[0] / z.radius);
  return h(t, n ? r : r - 360 * Math.floor((r + 180) / 360), s(.5 * Math.PI - 2 * Math.atan(Math.exp(-e[1] / z.radius))));
}

function Q(t, e) {
  var n = e[1];
  return n > 89.99999 ? n = 89.99999 : n < -89.99999 && (n = -89.99999), n = Math.sin(i(n)), h(t, i(e[0]) * z.radius, .5 * z.radius * Math.log((1 + n) / (1 - n)));
}

function B(t, e, n, r) {
  return r && n && !r.equals(n) && L(r, n) && r.isWebMercator ? r.isWebMercator ? Q(t, e) : U(t, e) : x(t, e);
}

function D(t) {
  return t.wkid ? t : t.spatialReference || N.WGS84;
}

function T(t, e) {
  return e.type ? h(t, e.x, e.y) : x(t, e);
}

function H(t) {
  return a(t);
}

function J(t, e) {
  return Math.max(t.width / e[0], t.height / e[1]) * ct(t.spatialReference);
}

function K(_x, _x2, _x3, _x4) {
  return _K.apply(this, arguments);
}

function _K() {
  _K = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t, a, i, s) {
    var c, u, _e4, _r2, _o, _e5, _iterator2, _step2, _n2, _t2, _r4, _o3, _r3, _i, _s, _iterator3, _step3, _t3, _iterator4, _step4, _e6, _iterator5, _step5, _t4, _e7, _n3, _o4, _a, f;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (t) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", null);

          case 2:
            if (!(Array.isArray(t) && !t.length)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", null);

          case 4:
            if (!(e.isCollection(t) && (t = t.toArray()), Array.isArray(t) && t.length && "object" == typeof t[0])) {
              _context.next = 39;
              break;
            }

            _e4 = t.every(function (t) {
              return "attributes" in t;
            }), _r2 = t.some(function (t) {
              return !t.geometry;
            });
            _o = t;

            if (!(_e4 && _r2 && a && a.allLayerViews)) {
              _context.next = 20;
              break;
            }

            _e5 = new Map();
            _iterator2 = _createForOfIteratorHelper(t);

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                _n2 = _step2.value;
                _t2 = _n2.layer, _r4 = _e5.get(_t2) || [], _o3 = _n2.attributes[_t2.objectIdField];
                null != _o3 && _r4.push(_o3), _e5.set(_t2, _r4);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            _r3 = [];

            _e5.forEach(function (t, e) {
              var n = a.allLayerViews.find(function (t) {
                return t.layer.id === e.id;
              });

              if ("queryFeatures" in n) {
                var _o2 = e.createQuery();

                _o2.objectIds = t, _o2.returnGeometry = !0, _r3.push(n.queryFeatures(_o2));
              }
            });

            _context.next = 15;
            return Promise.all(_r3);

          case 15:
            _i = _context.sent;
            _s = [];
            _iterator3 = _createForOfIteratorHelper(_i);

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                _t3 = _step3.value;

                if (_t3 && _t3.features && _t3.features.length) {
                  _iterator4 = _createForOfIteratorHelper(_t3.features);

                  try {
                    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                      _e6 = _step4.value;
                      n(_e6.geometry) && _s.push(_e6.geometry);
                    }
                  } catch (err) {
                    _iterator4.e(err);
                  } finally {
                    _iterator4.f();
                  }
                }
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }

            _o = _s;

          case 20:
            _iterator5 = _createForOfIteratorHelper(_o);
            _context.prev = 21;

            _iterator5.s();

          case 23:
            if ((_step5 = _iterator5.n()).done) {
              _context.next = 30;
              break;
            }

            _t4 = _step5.value;
            _context.next = 27;
            return K(_t4, a, i, s);

          case 27:
            s = _context.sent;

          case 28:
            _context.next = 23;
            break;

          case 30:
            _context.next = 35;
            break;

          case 32:
            _context.prev = 32;
            _context.t0 = _context["catch"](21);

            _iterator5.e(_context.t0);

          case 35:
            _context.prev = 35;

            _iterator5.f();

            return _context.finish(35);

          case 38:
            return _context.abrupt("return", s);

          case 39:
            if (!(Array.isArray(t) && 2 === t.length && "number" == typeof t[0] && "number" == typeof t[1])) {
              _context.next = 43;
              break;
            }

            c = new I(t);
            _context.next = 61;
            break;

          case 43:
            if (!(t instanceof F)) {
              _context.next = 47;
              break;
            }

            c = t;
            _context.next = 61;
            break;

          case 47:
            if (!("geometry" in t)) {
              _context.next = 61;
              break;
            }

            if (!t.geometry) {
              _context.next = 52;
              break;
            }

            c = t.geometry;
            _context.next = 61;
            break;

          case 52:
            if (!t.layer) {
              _context.next = 61;
              break;
            }

            _e7 = t.layer, _n3 = a.allLayerViews.find(function (t) {
              return t.layer.id === _e7.id;
            });

            if (!("queryFeatures" in _n3)) {
              _context.next = 61;
              break;
            }

            _o4 = _e7.createQuery();
            _o4.objectIds = [t.attributes[_e7.objectIdField]], _o4.returnGeometry = !0;
            _context.next = 59;
            return _n3.queryFeatures(_o4);

          case 59:
            _a = _context.sent;
            c = r(_a, "features", 0, "geometry");

          case 61:
            if (!o(c)) {
              _context.next = 63;
              break;
            }

            return _context.abrupt("return", null);

          case 63:
            if (!(u = "point" === c.type ? new q({
              xmin: c.x,
              ymin: c.y,
              xmax: c.x,
              ymax: c.y,
              spatialReference: c.spatialReference
            }) : c.extent, !u)) {
              _context.next = 65;
              break;
            }

            return _context.abrupt("return", null);

          case 65:
            f = O(u, i);
            return _context.abrupt("return", o(f) ? null : s = s ? s.union(f) : f);

          case 67:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[21, 32, 35, 38]]);
  }));
  return _K.apply(this, arguments);
}

function X(t) {
  if (t && (!Array.isArray(t) || "number" != typeof t[0]) && ("object" == typeof t || Array.isArray(t) && "object" == typeof t[0])) {
    if ("layer" in t && t.layer && t.layer.minScale && t.layer.maxScale) {
      var _e = t.layer;
      return {
        min: _e.minScale,
        max: _e.maxScale
      };
    }

    if (Array.isArray(t) && t.length && t.every(function (t) {
      return "layer" in t;
    })) {
      var _e2 = 0,
          _n = 0;

      var _iterator = _createForOfIteratorHelper(t),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _r = _step.value;
          var _t = _r.layer;
          _t && _t.minScale && _t.maxScale && (_e2 = _t.minScale < _e2 ? _t.minScale : _e2, _n = _t.maxScale > _n ? _t.maxScale : _n);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return _e2 && _n ? {
        min: _e2,
        max: _n
      } : null;
    }
  }
}

function Y(_x5, _x6) {
  return _Y.apply(this, arguments);
}

function _Y() {
  _Y = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, r) {
    var o, a, i, s, c, u, f, l, m, y, p, g, _t5, h, x, b;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(!e || !r)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", new t({
              targetGeometry: new I(),
              scale: 0,
              rotation: 0
            }));

          case 2:
            o = r.spatialReference;
            a = r.constraints, i = r.padding, s = r.viewpoint, c = r.size, u = [i ? c[0] - i.left - i.right : c[0], i ? c[1] - i.top - i.bottom : c[1]];
            f = null;
            e instanceof t ? f = e : e.viewpoint ? f = e.viewpoint : e.target && "esri.Viewpoint" === e.target.declaredClass && (f = e.target);
            l = null;

            if (!(f && f.targetGeometry)) {
              _context2.next = 11;
              break;
            }

            l = f.targetGeometry;
            _context2.next = 35;
            break;

          case 11:
            if (!(e instanceof q)) {
              _context2.next = 15;
              break;
            }

            l = e;
            _context2.next = 35;
            break;

          case 15:
            _context2.t0 = e || e && ("center" in e || "extent" in e || "target" in e);

            if (!_context2.t0) {
              _context2.next = 35;
              break;
            }

            _context2.next = 19;
            return K(e.center, r, o);

          case 19:
            _context2.t3 = _context2.sent;

            if (_context2.t3) {
              _context2.next = 24;
              break;
            }

            _context2.next = 23;
            return K(e.extent, r, o);

          case 23:
            _context2.t3 = _context2.sent;

          case 24:
            _context2.t2 = _context2.t3;

            if (_context2.t2) {
              _context2.next = 29;
              break;
            }

            _context2.next = 28;
            return K(e.target, r, o);

          case 28:
            _context2.t2 = _context2.sent;

          case 29:
            _context2.t1 = _context2.t2;

            if (_context2.t1) {
              _context2.next = 34;
              break;
            }

            _context2.next = 33;
            return K(e, r, o);

          case 33:
            _context2.t1 = _context2.sent;

          case 34:
            l = _context2.t1;

          case 35:
            !l && s && s.targetGeometry ? l = s.targetGeometry : !l && r.extent && (l = r.extent);
            m = D(l);

            if (!(o || (o = D(r.spatialReference || r.extent || l)), !L(l, o) && m && !m.equals(o))) {
              _context2.next = 39;
              break;
            }

            return _context2.abrupt("return", null);

          case 39:
            y = T(v(), l.center ? l.center : l), p = new I(B(y, y, m, o), o);
            g = null;
            if (f && n(f.targetGeometry) && "point" === f.targetGeometry.type) g = f.scale;else if (e.hasOwnProperty("scale") && e.scale) g = e.scale;else if (e.hasOwnProperty("zoom") && -1 !== e.zoom && a && a.effectiveLODs) g = a.zoomToScale(e.zoom);else if (Array.isArray(l) || "point" === l.type || "extent" === l.type && 0 === l.width && 0 === l.height) {
              _t5 = O(r.extent, o);
              g = n(_t5) ? J(_t5, u) : r.extent ? J(r.extent, u) : s.scale;
            } else g = L(l.extent, o) ? J(O(l.extent, o), u) : J(l.extent, u);
            h = X(e);
            h && (h.min && h.min > g ? g = h.min : h.max && h.max < g && (g = h.max));
            x = 0;
            f ? x = f.rotation : e.hasOwnProperty("rotation") ? x = e.rotation : s && (x = s.rotation);
            b = new t({
              targetGeometry: p,
              scale: g,
              rotation: x
            });
            return _context2.abrupt("return", (a && (b = a.fit(b), a.constrainByGeometry(b), a.rotationEnabled || (b.rotation = x)), b));

          case 48:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _Y.apply(this, arguments);
}

function Z(t, e) {
  var n = t.targetGeometry,
      r = e.targetGeometry;
  return n.x = r.x, n.y = r.y, n.spatialReference = r.spatialReference, t.scale = e.scale, t.rotation = e.rotation, t;
}

function $(t, e, n) {
  return n ? h(t, .5 * (e[0] - n.right + n.left), .5 * (e[1] - n.bottom + n.top)) : b(t, e, .5);
}

var _ = function () {
  var t = v();
  return function (e, n, r) {
    var o = n.targetGeometry;
    T(t, o);
    var a = .5 * at(n);
    return e.xmin = t[0] - a * r[0], e.ymin = t[1] - a * r[1], e.xmax = t[0] + a * r[0], e.ymax = t[1] + a * r[1], e.spatialReference = o.spatialReference, e;
  };
}();

function tt(t, e, n, r, o) {
  return wt(t, e, n.center), t.scale = J(n, r), o && o.constraints && o.constraints.constrain(t), t;
}

function et(t, e, n, r) {
  return mt(t, e, n, r), y(t, t);
}

function nt(t, e, n) {
  var r = st(e),
      o = Math.abs(Math.cos(r)),
      a = Math.abs(Math.sin(r));
  return h(t, Math.round(n[1] * a + n[0] * o), Math.round(n[1] * o + n[0] * a));
}

var rt = function () {
  var t = v();
  return function (e, n, r) {
    return d(e, ut(e, n), $(t, n, r));
  };
}(),
    ot = function () {
  var t = g(),
      e = v();
  return function (n, r, o, a) {
    var i = at(r),
        s = st(r);
    return h(e, i, i), c(t, e), u(t, t, s), f(t, t, rt(e, o, a)), f(t, t, [0, a.top - a.bottom]), h(n, t[4], t[5]);
  };
}();

function at(t) {
  return t.scale * it(t.targetGeometry);
}

function it(t) {
  return n(t) && V(t.spatialReference) ? 1 / (H(t.spatialReference) * W * ft()) : 1;
}

function st(t) {
  return i(t.rotation) || 0;
}

function ct(t) {
  return V(t) ? H(t) * W * ft() : 1;
}

function ut(t, e) {
  return b(t, e, .5);
}

function ft() {
  return 96;
}

var lt = function () {
  var t = v(),
      e = v(),
      n = v();
  return function (r, o, a, i, s, c) {
    return w(t, o), b(e, a, .5 * c), h(n, 1 / i * c, -1 / i * c), l(r), f(r, r, e), s && u(r, r, s), m(r, r, n), f(r, r, t), r;
  };
}(),
    mt = function () {
  var t = v();
  return function (e, n, r, o) {
    var a = at(n),
        i = st(n);
    return T(t, n.targetGeometry), lt(e, t, r, a, i, o);
  };
}(),
    yt = function () {
  var t = v();
  return function (e, n, r, o) {
    var a = at(n);
    return T(t, n.targetGeometry), lt(e, t, r, a, 0, o);
  };
}();

function pt(t) {
  if (t.isWrappable) {
    var _e3 = E(t);

    return _e3.valid[1] - _e3.valid[0];
  }

  return 0;
}

function gt(t, e) {
  return Math.round(pt(t) / e);
}

function ht(t, e) {
  return Y(t, e);
}

var xt = function () {
  var t = v(),
      e = v(),
      n = [0, 0, 0];
  return function (r, o, a) {
    j(t, r, o), G(t, t), j(e, r, a), G(e, e), M(n, t, e);
    var i = Math.acos(k(t, e) / (A(t) * A(e))) * C;
    return n[2] < 0 && (i = -i), isNaN(i) && (i = 0), i;
  };
}(),
    bt = function () {
  var t = v();
  return function (e, n, r, o) {
    var a = e.targetGeometry;
    return Z(e, n), ot(t, n, r, o), a.x += t[0], a.y += t[1], e;
  };
}(),
    dt = function () {
  var t = v();
  return function (e, n, r, o) {
    var a = e.targetGeometry;
    return Z(e, n), ot(t, n, r, o), a.x -= t[0], a.y -= t[1], e;
  };
}(),
    wt = function () {
  var t = v();
  return function (e, n, r) {
    Z(e, n);
    var o = e.targetGeometry,
        a = D(r),
        i = D(o);
    return T(t, r), B(t, t, a, i), o.x = t[0], o.y = t[1], e;
  };
}();

function jt(t) {
  return at(t);
}

var Gt = function () {
  var t = v();
  return function (e, n, r, o, a) {
    a || (a = "center"), d(t, r, o), b(t, t, .5);
    var i = t[0],
        s = t[1];

    switch (a) {
      case "center":
        h(t, 0, 0);
        break;

      case "left":
        h(t, -i, 0);
        break;

      case "top":
        h(t, 0, s);
        break;

      case "right":
        h(t, i, 0);
        break;

      case "bottom":
        h(t, 0, -s);
        break;

      case "top-left":
        h(t, -i, s);
        break;

      case "bottom-left":
        h(t, -i, -s);
        break;

      case "top-right":
        h(t, i, s);
        break;

      case "bottom-right":
        h(t, i, -s);
    }

    return Ft(e, n, t), e;
  };
}();

function Mt(t, e, n) {
  return Z(t, e), t.rotation += n, t;
}

function kt(t, e, n) {
  return Z(t, e), t.rotation = n, t;
}

var At = function () {
  var t = v();
  return function (e, n, r, o, a) {
    return Z(e, n), isNaN(r) || 0 === r || (Pt(t, o, n, a), e.scale = n.scale * r, qt(t, t, e, a), Ft(e, e, h(t, t[0] - o[0], o[1] - t[1]))), e;
  };
}();

function Rt(t, e, n) {
  return Z(t, e), t.scale = n, t;
}

var St = function () {
  var t = v();
  return function (e, n, r, o, a, i) {
    return Z(e, n), isNaN(r) || 0 === r || (Pt(t, a, n, i), e.scale = n.scale * r, e.rotation += o, qt(t, t, e, i), Ft(e, e, h(t, t[0] - a[0], a[1] - t[1]))), e;
  };
}(),
    vt = function () {
  var t = v(),
      e = v();
  return function (n, r, o, a, i, s, c) {
    return rt(e, s, c), S(t, i, e), a ? St(n, r, o, a, t, s) : At(n, r, o, t, s);
  };
}(),
    Pt = function () {
  var t = g();
  return function (e, n, r, o) {
    return R(e, n, et(t, r, o, 1));
  };
}(),
    qt = function () {
  var t = g();
  return function (e, n, r, o) {
    return R(e, n, mt(t, r, o, 1));
  };
}(),
    Ft = function () {
  var t = v(),
      e = g();
  return function (n, r, o) {
    Z(n, r);
    var a = at(r),
        i = n.targetGeometry;
    return p(e, st(r)), m(e, e, P(a, a)), R(t, o, e), i.x += t[0], i.y += t[1], n;
  };
}();

export { bt as addPadding, xt as angleBetween, wt as centerAt, Z as copy, Y as create, ht as createAsync, J as extentToScale, $ as getAnchor, _ as getExtent, lt as getMatrix, nt as getOuterSize, ot as getPaddingMapTranslation, rt as getPaddingScreenTranslation, at as getResolution, ct as getResolutionToScaleFactor, mt as getTransform, yt as getTransformNoRotation, gt as getWorldScreenWidth, pt as getWorldWidth, vt as padAndScaleAndRotateBy, jt as pixelSize, dt as removePadding, Gt as resize, Mt as rotateBy, kt as rotateTo, St as scaleAndRotateBy, At as scaleBy, Rt as scaleTo, tt as setExtent, Pt as toMap, qt as toScreen, Ft as translateBy };